import axios from "axios";
import { StopPoint } from "./types";
import { localStorageProxy } from "../lib/utils";

function gtfsGetLineStops(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  line: string,
  direction?: string,
  onlyPhysicals?: Boolean
): Promise<StopPoint[]> {
  // pagination max=1000 pour récupérer tous les arrêts
  let url = `/stops-line-discovery?max=1000&reseau=${network}&line=${line}`;
  if (typeof direction == 'undefined') {
    direction = '';
  }
  url += `&direction=${direction}`;
  if (typeof onlyPhysicals !== 'undefined') {
    let physicals = onlyPhysicals ? 1 : 0;
    url += `&onlyphysicals=${physicals}`;
  }
  if (encodeUriPath) {
    url = encodeURIComponent(url);
  }
  url = `${gtfsUri}${url}`;
  return axios({ method: "get", url }).then(resp => {
    // Temporary remove element TransfersLines inside result object.
    delete resp.data.items.TransfersLines;

    let stops = Object.values(resp.data.items);
    return stops;
  });
}

export default async function (
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  line: string,
  direction: string,
  onlyPhysicals?: Boolean,
): Promise<StopPoint[]> {
  let prefix = `${gtfsUri}-${network}`;

  let proxyGetValue: Function = localStorageProxy(
    prefix + "lineStops" + line + "dir" + direction + "onlyPhysicals" + (onlyPhysicals ? 1 : 0),
    () => gtfsGetLineStops(gtfsUri, encodeUriPath, network, line, direction, onlyPhysicals),
  );
  
  return proxyGetValue();
}
